import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function JiraIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4114 7.74495C12.5573 7.89079 12.5573 8.12777 12.4114 8.2736C8.29163 12.3752 14.9088 5.7762 7.99996 12.6668C4.70048 9.38558 5.99475 10.6799 3.5885 8.2736C3.44267 8.12777 3.44267 7.89079 3.5885 7.74495C3.5885 7.74495 4.99215 6.34131 7.99996 3.3335C9.31246 4.646 11.0807 6.41423 12.4114 7.74495ZM7.99996 9.38558L9.38538 8.00016L7.99996 6.63298L6.61454 8.00016L7.99996 9.38558Z"
        fill="currentColor"
        fill-opacity="0.6"
      />
    </svg>
  );
};
